import { render, staticRenderFns } from "./ArticleGridBNG.vue?vue&type=template&id=1ce5b987&scoped=true"
import script from "./ArticleGridBNG.vue?vue&type=script&lang=js"
export * from "./ArticleGridBNG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5b987",
  null
  
)

export default component.exports